import FactorHealthCard from './FactorHealthCard'

export {FactorHealthCard}
export default FactorHealthCard
